module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-21-b7a118d6b61544204b04e8d8fee8f867.png";